import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { NotificationsService } from '../../../core/service/notifications.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LinkedinService } from 'src/app/domain/components-page/service/linkedin.service';
import { RegExpService } from 'src/app/util/common/reg-exp.service';
import { VerticalChartObject } from '../../shared/component/vertical-charts/vertical-charts.component';

@Component({
  selector: 'app-components-page',
  templateUrl: './component-page.component.html',
  styleUrls: ['./component-page.component.scss'],
})
export class ComponentPageComponent implements OnInit {
  nameControl: FormControl;

  form: FormGroup<{
    firstArray: FormArray<
    FormGroup<{
      name: FormControl<string>;
      secondArray: FormArray<FormGroup<{
        name: FormControl<string>;
        thirdArray: FormArray<FormGroup<{
          roundNumber: FormControl<number>;
          companies: FormControl<number>;
        }>>;
      }>
      >;
    }>
    >;
  }>;

  editMode = new Map<number, boolean>();
  submitFormValue = '';

  graphicData: VerticalChartObject = {
    agenda: [
      {
        color: '#B2B2B4',
        title: 'Total commitment',
      },
      {
        color: '#5E6F78',
        title: 'Contribution received',
      },
      {
        color: '#5CC3BB',
        title: 'Net Gain',
      },
    ],
    graphics: [
      {
        title: 'Hanaco',
        bars: [
          { parts: [{ color: '#FF8078', amount: -150 }] },
          { parts: [{ color: '#FF8078', amount: -150 }, { color: '#FF8078', amount: -150 }] },
          {
            parts: [{ color: '#FF8078', amount: -150 }, { color: '#FF8078', amount: -150 }, {
              color: '#FF8078',
              amount: -150,
            }],
          },
        ],
      },
      {
        title: 'Hanaco G',
        bars: [
          { parts: [{ color: '#B2B2B4', amount: 150 }] },
          { parts: [{ color: '#B2B2B4', amount: 150 }, { color: '#B2B2B4', amount: 150 }] },
          { parts: [{ color: '#B2B2B4', amount: 150 }, { color: '#B2B2B4', amount: 150 }, { color: '#B2B2B4', amount: 150 }] },
        ],
      },
      {
        title: 'Hanaco X',
        bars: [
          {
            parts: [{ color: '#FF8078', amount: -150 }, { color: '#B2B2B4', amount: 150 }, {
              color: '#FF8078',
              amount: -150,
            }],
          },
          { parts: [{ color: '#B2B2B4', amount: 150 }, { color: '#FF8078', amount: -150 }, { color: '#B2B2B4', amount: 150 }] },
          { parts: [{ color: '#B2B2B4', amount: 150 }, { color: '#B2B2B4', amount: 150 }, { color: '#FF8078', amount: -150 }] },
          { parts: [{ color: '#FF8078', amount: -150 }, { color: '#B2B2B4', amount: 150 }, { color: '#B2B2B4', amount: 150 }] },
        ],
      },
    ],
  };

  @ViewChild('div') div: ElementRef;
  @ViewChild('divB') divb: ElementRef;

  checkboxValue: string;
  select: number;
  inputValue;
  selectedIndex = 0;
  orgs = [];
  simpleStringArray = ['one', 'two', 'kek'];
  showThisCoolModal = false;
  showPopUpModal = false;
  modalButtons = {
    close: true,
    apply: 'Apply',
    dismiss: 'Dismiss',
  };

  selectedTab = 'drop-down';
  selectedInputTab = 'Vanilla';
  selectedSelectorsTab = 'Used';
  selectedInputsTab = 'Used';
  selectedIconTab = 'Used';

  isButtonLocked = false;
  // Auto-input
  complexData = new Map<string, number>([
    ['First kek', 58], ['Second kek', 76], ['Third kek', 130],
  ]);

  autoInputValue: number;
  open = {
    openModalNoTExt: false,
    openModalWithText: false,
    openModalMInTExtAndAdditional: false,
    openModalNoInput: false,
  };

  textForToolTip = 'Test test test test test test test test test test test test test test test test test test tets';

  constructor(private notificationsService: NotificationsService,
    private linkedIn: LinkedinService,
    private fb: FormBuilder,
  ) {
    const o1 = new Organization();
    o1.name = 'kek';
    o1.logo = 'abir';
    const o2 = new Organization();
    o2.name = 'lol';
    o2.logo = 'riba';
    this.orgs.push(o1);
    this.orgs.push(o2);
  }

  ngOnInit(): void {
    this.nameControl = new FormControl(123456, {
      validators:
        [Validators.required,
          Validators.pattern(RegExpService.integerOrNull)], updateOn: 'change',
    });

    this.editMode.set(1, false);
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      firstArray: this.fb.array([
        this.fb.group({
          name: new FormControl('vanya', { validators: [Validators.required] }),
          secondArray: this.fb.array([
            this.fb.group({
              name: new FormControl('sub-vanya'),
              thirdArray: this.fb.array([
                this.fb.group({
                  roundNumber: new FormControl(1),
                  companies: new FormControl(5),
                }),
              ]),
            }),
          ]),
        }),
      ]),
    });

  }

  submit(): void {
    this.submitFormValue = JSON.stringify(this.form.value);
  }

  sendSuccess(): void {
    this.notificationsService.success({
      title: 'Success',
      message: 'Woohoo, it worked !',
    });
  }

  async catchName(name: string): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await this.linkedIn.getTestCompanyFromLinkedInByName(name);
  }
  // //////////////////////////////// modals delete ///////////////
}
